import { SET_CUSTOMER_INFORMATION } from "../../constants";
import { getCustomerInformationFromLocalStorage } from "../../selectors";

import { createAction } from "../../utils";

const setCustomerInformation = createAction(SET_CUSTOMER_INFORMATION);

export const setCustomerInformationInLocalStorage =
  (fieldName, fieldValue) => (dispatch, getState) => {
    const customerData = getCustomerInformationFromLocalStorage(getState());
    const formType =
      customerData.activeForm === "customer" ? "customer" : "registrant";

    const updatedData = {
      ...customerData,
      [formType]: {
        ...(customerData && customerData[formType]),
        [fieldName]: fieldValue,
      },
    };

    // Clear citizenship after every country change
    if (fieldName === "country" && updatedData[formType].citizenship) {
      delete updatedData[formType].citizenship;
    }

    window.localStorage.setItem(
      "customerInformation",
      JSON.stringify({ ...updatedData }),
    );

    return dispatch(
      setCustomerInformation({ formType, fieldValue, fieldName }),
    );
  };
